import { DomSanitizer } from '@angular/platform-browser';
import { EmailService } from './../../../../../Services/email.service';
import { SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit ,Input , OnDestroy } from '@angular/core';
import { Helper } from 'src/app/helpers/helper.service';
import { SolutionService } from 'src/app/back-office/Services/solution.service';
import { Solution } from 'src/app/back-office/Models/Solution';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ActionEmail } from 'src/app/back-office/Models/ActionEmail';
import {animate, style, transition, trigger} from '@angular/animations';
import * as Mustache from 'mustache';


@Component({
  selector: 'app-solution-action-email',
  templateUrl: './solution-action-email.component.html',
  styleUrls: ['./solution-action-email.component.scss'],
  animations: [
    trigger('fadeInOutTranslate', [
      transition(':enter', [
        style({opacity: 0}),
        animate('400ms ease-in-out', style({opacity: 1}))
      ]),
      transition(':leave', [
        style({transform: 'translate(0)'}),
        animate('400ms ease-in-out', style({opacity: 0}))
      ])
    ])
  ]
})
export class SolutionActionEmailComponent implements OnInit , OnDestroy {
  @Input() Index: number;

  public solution: Solution = new Solution();
  private subscriptions: Subscription[] = [];
  public tokens = [];
  public rawTokens: any;
  public tabs = [];
  public modules;
  public iframeUrl: SafeResourceUrl;
  public emailBaseTemplate;
  public actionEmailTemplate;

  constructor(
    private solutionService: SolutionService,
    public helper: Helper,
    private translate: TranslateService,
    private emailService: EmailService,
    private sanitizer: DomSanitizer,
  ) {

    this.modules = {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],        

        [{'header': 1}, {'header': 2}],               
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'indent': '-1'}, {'indent': '+1'}],          
        [{'direction': 'rtl'}],                        

        [{'size': ['small', false, 'large', 'huge']}],
        [{'header': [1, 2, 3, 4, 5, 6, false]}],

        [{'color': []}, {'background': []}],
        [{'align': []}],
        ['link']
      ]
    };

    this.tabs = [
      {title:'body' , mapping:'contentBody'},
      {title:'title' , mapping:'contentTitle'},
      {title:'footer' , mapping:'contentFooter'},
    ];

    this.tokens = [
      {description:'current_user' , name:'{{current_user.fullname}}'},
      {description:'order_number' , name:'{{order.orderNo}}'},
    ];

    

   }

  ngOnInit() {
    this.subscriptions.push(
      this.solutionService.solution.subscribe(solution => {
        this.solution = solution;
        if (this.solution.solutionSteps[this.Index] && !this.solution.solutionSteps[this.Index].actionEmail) {
          this.solution.solutionSteps[this.Index].actionEmail = new ActionEmail();
        }
      })
    );

    this.subscriptions.push(
      this.emailService.getTemplate().subscribe((res) =>{
        this.emailBaseTemplate = res;
        this.subscriptions.push(
          this.emailService.getActionEmailBaseTemplate().subscribe((template) =>{
            this.actionEmailTemplate = template;
            this.subscriptions.push(
              this.emailService.getTokens('custom_email').subscribe((token_resp) => {
                this.rawTokens = token_resp.rawTokens;
                this.updateEmailBody();
              })
            )
          })
        );
      })
    );    
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  updateEmailBody(){
    try {
      const preview = Mustache.render(this.actionEmailTemplate.content, this.rawTokens, {title: this.solution.solutionSteps[this.Index].actionEmail.contentTitle , body: this.solution.solutionSteps[this.Index].actionEmail.contentBody , footer: this.solution.solutionSteps[this.Index].actionEmail.contentFooter});
      const htmlPreview = Mustache.render(this.emailBaseTemplate.content, this.rawTokens, {contentBody: preview});
      this.updateIframe(htmlPreview);
    } catch (e) {
    }
  }

  updateIframe(html) {
    const encodedHtml = btoa(encodeURIComponent(html).replace(/%([0-9A-F]{2})/g,
      (match, p1) => String.fromCharCode(parseInt(p1, 16))));
    const dataUrl = `data:text/html;base64,${encodedHtml}`;
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(dataUrl);
  }

  clipboardUpdated() {
    this.helper.showNotify('',
      this.translate.instant('admin.emails.manage.copied_to_clipboard'),
      'success'
    );
  }

  updateSolution() {
    this.solutionService.solution.next(this.solution);
  }

}
